/*
  TODO: Migrate to proper VUe3 composition api:
  https://glittrsoftware.visualstudio.com/glittr.core/_workitems/edit/8089
*/

/* eslint-disable no-use-before-define */
import _ from '../../../utils';
import DataEvent from './data-event';
import type DataSource from './data-source';
import { UnpackDataRecord } from './data-source';

/** Checks if the value is a DataRecord or not */
export const isDataRecord = <T>(value: DataRecord<UnpackDataRecord<T>> | T): value is DataRecord<UnpackDataRecord<T>> => !!(value as any)?._thisIsADataRecord;
/** Unwraps the value. If the value is a DataRecord it returns the data that is wrapped, otherwise it will simply return the value as is */
export const unwrapDataRecord = <T>(value: DataRecord<UnpackDataRecord<T>> | T): T => (isDataRecord(value) ? value.data : value);

export type DataRecordWrapResponse<T> = T extends {items?: any[]} ? Omit<T, 'items'> & {items: DataRecord<NonNullable<T['items']>[0]>[];} : DataRecord<T>;

export const wrapResponseWithDataRecord = <T>(res: T): DataRecordWrapResponse<T> => {
  let clone = _.deepClone(res) as any;
  if (Array.isArray(clone?.items)) clone.items = clone.items.map((i: any) => new DataRecord(i));
  else clone = new DataRecord(clone);
  return clone;
};

export default class DataRecord<TData = any> {
  onSelectionChanged = new DataEvent<[any]>();
  private _isSelected: boolean = false;
  private _dataSource?: DataSource;
  data: TData;
  isInEditMode: boolean = false;

  constructor(data: TData, dataSource?: DataSource<TData>) {
    // Don't enumerate the private member _dataSource because it contains cyclic references when resolved
    // It should not be serialized anyway
    Object.defineProperty(this, '_dataSource', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: dataSource,
    });
    Object.defineProperty(this, '_thisIsADataRecord', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: true,
    });
    this.data = data;
  }

  async update() {
    if (this._dataSource) {
      await this._dataSource.update(this.data);
    }
  }

  async delete() {
    if (this._dataSource) {
      const { id } = this.data as any;
      if (id === undefined || id === null) {
        throw new Error('No id was present while deleting the data record');
      }
      await this._dataSource.delete(id);
    }
  }

  get isSelected() { return this._isSelected; }
  set isSelected(value: boolean) {
    if (this._isSelected !== value) {
      this._isSelected = value;
      this.onSelectionChanged.invoke(this);
    }
  }

  // abstract items: any;
}
